import { ProductTypeT } from "src/pages/product/product-types";
import { BillingDetail } from "../billingSchedule/billing-type";
import { MbOrgDetail, SaveMediaDto } from "../organization/org-types";
import { ApplicationFormModel, VisitorApproverMemberType } from "../product/product-types";
import { ProviderDetailModel } from "../provider/provider-types";
import { Address, CommonDateNUser, MediaFile, MeetingRoom, Order, PakringLot, Select } from "../public-types";

export enum SpaceProductType {
  FULL_COURT = "FULL_COURT",
  OPEN_COURT = "OPEN_COURT",
  TIME_COURT = "TIME_COURT",
}

export enum ContractStep {
  // 신청접수
  APPLY_RECEIVED = "APPLY_RECEIVED",
  // 신청취소
  APPLY_CANCEL = "APPLY_CANCEL",
  // 신청확인
  APPLY_CONFIRM = "APPLY_CONFIRM",
  // 계약예정
  CONTRACT_PLAN = "CONTRACT_PLAN",
  // 이용완료
  USE_COMPLETE = "USE_COMPLETE",
  // 계약체결
  CONTRACT_ACCEPT = "CONTRACT_ACCEPT", //
  // 이용승인
  USE_APPROVAL = "USE_APPROVAL", //
  // 이용중
  USE_PROGRESS = "USE_PROGRESS", //
  // 해지접수
  TERMINATE_RECEIVED = "TERMINATE_RECEIVED", //
  // 해지완료
  TERMINATE_COMPLETE = "TERMINATE_COMPLETE",
}

export const searchStatusOption: Select[] = [
  { label: "전체", value: "" },
  // { label: "신청접수", value: ContractStep.APPLY_RECEIVED },
  { label: "신청취소", value: ContractStep.APPLY_CANCEL },
  { label: "신청확인", value: ContractStep.APPLY_CONFIRM },
  { label: "계약예정", value: ContractStep.CONTRACT_PLAN },
  { label: "계약체결", value: ContractStep.CONTRACT_ACCEPT },
  { label: "이용승인", value: ContractStep.USE_APPROVAL },
  { label: "이용중", value: ContractStep.USE_PROGRESS },
  { label: "이용완료", value: ContractStep.USE_COMPLETE },
  { label: "해지접수", value: ContractStep.TERMINATE_RECEIVED },
  { label: "해지완료", value: ContractStep.TERMINATE_COMPLETE },
];

export enum ApplicationName {
  //신청/계약(계약) id
  CONTRACT_ID = "CONTRACT_ID",
  //공간상품 id
  SPACE_PRODUCT_ID = "SPACE_PRODUCT_ID",
  //공간상품명
  SPACE_PRODUCT_NAME = "SPACE_PRODUCT_NAME",
  //신청/계약자명
  CONTRACTOR_NAME = "CONTRACTOR_NAME",
  //신청/계약자명
  CONTRACT_MEMBER_NO = "CONTRACT_MEMBER_NO",
  //신청/계약자 법인명/상호
  APPLICANT_CORPORATION = "APPLICANT_CORPORATION",
  CONTRACT_APPLY_NUMBER = "CONTRACT_APPLY_NUMBER",
  CONTRACT_NUMBER = "CONTRACT_NUMBER",
  //계약관리 id (신청번호 대체 검색조건)
  CONTRACT_MANAGE_ID = "CONTRACT_MANAGE_ID",
  //계약명
  CONTRACT_NAME = "CONTRACT_NAME",
  MB_ORGANIZATION_ID = "MB_ORGANIZATION_ID",
}

// 조건검색 검색어 옵션 (컬럼 테이블 배치 순서에 맞춤)
// 신청번호/계약번호는 계약관리 ID로 대체되어 검색옵션에서 제거했다.
// TODO(BE): 계약관리 ID 검색은 RCA10 의 searchType 에 CONTRACT_MANAGE_ID 가 추가 배포된 뒤 동작한다.
export const searchTypeOption: Select[] = [
  { label: "전체", value: "" },
  { label: "계약 ID", value: ApplicationName.CONTRACT_ID },
  { label: "계약관리 ID", value: ApplicationName.CONTRACT_MANAGE_ID },
  { label: "계약자명", value: ApplicationName.CONTRACTOR_NAME },
  { label: "계약명", value: ApplicationName.CONTRACT_NAME },
  { label: "상품명", value: ApplicationName.SPACE_PRODUCT_NAME },
  { label: "상품 ID", value: ApplicationName.SPACE_PRODUCT_ID },
];

export const searchDateTypeOption: Select[] = [
  { label: "전체", value: "" },
  { label: "시작일", value: "CONTRACT_START_TIME" },
  { label: "종료일", value: "CONTRACT_END_TIME" },
];

export enum MediaServiceType {
  // 정의되지 않은 타입
  MEDIASERVICE_UNRECOGNIZED = "MEDIASERVICE_UNRECOGNIZED",
  // 건물
  BUILDING = "BUILDING",
  // 건물 층
  BUILDING_FLOOR = "BUILDING_FLOOR",
  // 건물 호실
  BUILDING_ROOM = "BUILDING_ROOM",
  // 회의실
  BUILDING_MEETING_ROOM = "BUILDING_MEETING_ROOM",
  // 데스크공간
  BUILDING_DESK_SPACE = "BUILDING_DESK_SPACE",
  // 리프레쉬공간
  BUILDING_REFRESH = "BUILDING_REFRESH",
  // 상품서비스
  PRODUCT = "PRODUCT",
  // 공간상품평면도
  PRODUCT_FLOOR_PLAN = "PRODUCT_FLOOR_PLAN",
  // 공간상품 시설/공용공간
  PRODUCT_FACILITY = "PRODUCT_FACILITY",
}
// 계약 승인 유형
export type ContractApprovalType = "AUTO" | "ADMIN" | "";

// 계약 승인 상태
export type ContractApprovalStatus = "PENDING" | "APPROVED" | "REJECTED" | "";

//목록 검색
export type ContractSearchParams = {
  id?: number;
  contractStep?: string;
  searchType?: string;
  searchValue?: string;
  //검색일(from) YYYY-MM-DD
  searchStartTime?: string;
  //검색일(to) YYYY-MM-DD
  searchEndTime?: string;
  contractIds?: string;
  contractManageIds?: string;
  page?: number;
  size?: number;
  searchTimeType?: string;
  sort?: {
    orders: Array<Order>;
  };
  buildingIds?: string;
  spaceProductType?: string; // 상품 타입 FULL_COURT 등
  isUseFacility?: boolean; //공용공간 사용여부 (미입력 : 전체(Default), TRUE : 사용, FALSE : 미사용)
  approvalType?: ContractApprovalType;
  approvalStatus?: ContractApprovalStatus;
  providerIds?: string;
};

export interface ContractManageList {
  contractManageId: number;
  contractId: number;
  spaceProductName: string;
  spaceProductId: number;
  contractName: string;
  /** 계약명(선택) */
  contractNickname?: string;
  /** 계약자명 */
  contractorName: string;
  /** 이용신청자 이름 */
  applicantName: string;
  applicantCorporation: string;
  contractStartTime: string;
  contractEndTime: string;
  contractTerm: string;
  createdDate: string;
  modifiedDate: string;
  partnerId?: string;
  contractStep: string;
  contractMemberNo: string;
  contractMemberId: string;
  contractApplyNumber: string;
  contractNumber: string;
  contractDate: string;
  /** 이용신청서 id (유무 판단용) */
  applicationId?: number;
  /** 이용자 수(명) */
  memberTotCount?: number;
  /** 정원(명) */
  memberMaxNums?: number;
  mbOrganizationName?: string;
  isUseMeetingRoom?: boolean; // 회의실 사용여부
  isUseRefreshRoom?: boolean; // 리프레쉬룸 사용여부
  isUseDesk?: boolean; // 데스크 사용여부
  isUseVisitorInvite?: boolean;
  facilityNums?: number; // 전체 공용시설수
  spaceProductType?: string; // 상품 타입 FULL_COURT 등 > 삭제예정
  productTypes?: string; // 상품 타입 FULL_COURT 등
  buildingId?: number;
}

//CCA19. 계약(이용) 중인 신청/계약 목록 조회

export interface ContractUseRequestModel {
  contractManageId: number;
  contractApplyNumber: string;
  contractId: number;
  contractMemberId: number;
  memberNo: string;
  spaceProductId: number;
  spaceProductType: string;
  spaceProductName: string;
  contractStep: string;
  useTerm: number;
  useStartTime: string;
  useEndTime: string;
  contractTerm: number;
  contractStartTime: string;
  contractEndTime: string;
  inviteDate: string;
  isContractor: boolean;
  isAdmin: boolean;
  memberTotCount: number;
  memberMaxNums: number;
}

export interface ContractUseRequestList {
  content: Array<ContractUseRequestModel>;
}

export interface ContractDetailBasicInfo {
  contractId: number;
  contractManageId: number;
  contractApplyNumber?: string;
  contractStep: string;
  createdDate: string;
  modifiedDate: string;
  modifiedBy?: string;
}

//계약서
export interface CtMediaFile {
  id: number;
  serviceId: string;
  serviceType: string;
  serviceTag: string;
  mediaType: string;
  originMediaName: string;
  description: string;
  mediaPath: string;
  isPrimary: boolean;
  orderNums: number;
  isDeleted: boolean;
}

//계약상품
export interface CotractProduct {
  buildingUid: number;
  buildingName: string;
  description: string;
  floorNums: number;
  undergroundFloorNums: number;
  feature: string;
  completionYmd: string;
  entryStartTime: string;
  entryEndTime: string;
  passengerElev: number;
  freightElev: number;
  fileList: Array<MediaFile>;
  meetingRoomList: Array<MeetingRoom>;
  parkingLotList: Array<PakringLot>;
  address: Address;
}

export enum MemberStatus {
  //초대
  MEMBER_INVITE = "MEMBER_INVITE",
  //사용
  MEMBER_USE = "MEMBER_USE",
  //삭제
  MEMBER_DELETE = "MEMBER_DELETE",
  //종료
  MEMBER_CLOSE = "MEMBER_CLOSE",
}

//이용자
export interface CtMember {
  contractMemberId: number;
  contractManageId: number;
  inviteMobileNumber: number;
  memberNo: number;
  isContractor: boolean;
  isAdmin: boolean;
  inviteDate: string;
  memberStatus: string;
  useTime: string;
  isDeleted: boolean;
  createdDate: string;
  createdBy: string;
  modifiedDate: string;
  modifiedBy: string;
}

export enum VisitStatus {
  // 사용
  VISIT_USE = "VISIT_USE",
  // 일시정지
  VISIT_PAUSE = "VISIT_PAUSE",
  // 삭제
  VISIT_DELETE = "VISIT_DELETE",
  // 종료
  VISIT_CLOSE = "VISIT_CLOSE",
}
// 방문자 관리
export interface CtVisitor {
  visitorId: number;
  contractManageId: number;
  visitorName: string;
  visitorMobileNumber: string;
  visitorCarNumber: string;
  visitStartTime: string;
  visitEndTime: string;
  visitStatus: string;
  isDeleted: boolean;
  createdDate: string;
  createdBy: string;
  modifiedDate: string;
  modifiedBy: string;
}

//계약관리
export interface CtContractManage {
  contractManageId: number;
  contractId: number;
  contractApplyType: string;
  useStartTime: string;
  useEndTime: string;
  applicantName: string;
  applicantCorporation: string;
  isAgreeTerms: boolean;
  businessRegNumber: string;
  spaceProductId: number;
  spaceProductName: string;
  accessGroupId: number;
  isDeleted: boolean;
  createdDate: string;
  createdBy: string;
  modifiedDate: string;
  modifiedBy: string;
}

//계약 메모
export interface CtContractMemo {
  contractMemoId: number;
  contractManageId: number;
  contractMemo: string;
  isDeleted: boolean;
  createdDate: string;
  createdBy: string;
  modifiedDate: string;
  modifiedBy: string;
}

// 계약
export interface CtContract {
  contractId: number;
  contractManageId: number;
  contractStep: string;
  contractDate: string;
  contractTerm: number;
  contractStartTime: string;
  contractEndTime: string;
  depositAmount: string;
  earnestAmount: string;
  earnestPayStatus: string;
  balanceAmount: string;
  balancePayStatus: string;
  isContractCancel: boolean;
  contractCancelDate: string;
  contractCancelStartOrder: number;
  contractCancelReason: string;
  contractBillTimeType: string;
  contractPayType?: string;
  pgcode: string;
  payAmount: string;
  payRegularDate: number;
  billkey: string;
  taxBillReceiveEmail: string;
  taxBillChargeAmount: string;
  taxBillManageAmount: string;
  taxBillRegularDate: number;
  isDeleted: boolean;
  createdDate: string;
  createdBy: string;
  modifiedDate: string;
  modifiedBy: string;
}

export enum PayStatus {
  //결제 대기
  PAY_WAIT = "PAY_WAIT",
  //결제 완료
  PAY_COMPLETE = "PAY_COMPLETE",
}

export enum BillTimeType {
  //즉시결제
  IMMEDIATE_PAYMENT = "IMMEDIATE_PAYMENT",
  //정기결제
  REGULAR_PAYMENT = "REGULAR_PAYMENT",
}

export enum PayType {
  // 일반결제형
  PAY = "PAY",
  // 세금계산서 발행
  TAX = "TAX",
}

export enum PgCodeType {
  // 신용카드
  CREADIT_CARD = "creditcard",
  //가상계좌
  VIRTUAL_ACCOUNT = "virtualaccount",
}

export interface CtBill {
  billId: number;
  contractId: number;
  billNumber: string;
  billTimeType: string;
  billPayType: string;
  billCustomerName: string;
  billOrder: number;
  billIssueDate: string;
  billStartTime: string;
  billEndTime: string;
  beforeDiscountAmount: number;
  discountAmount: number;
  billAmount: number;
  billPayStatus: string;
  isDeleted: boolean;
}

// interface CtPayment {
//   payId: number;
//   billId: number;
//   pgcode: string;
//   clientId: string;
//   serviceName: string;
//   userId: string;
//   userName: string;
//   orderNo: string;
//   amount: string;
//   taxfreeAmount: string;
//   taxAmount: string;
//   productName: string;
//   emailFlag: boolean;
//   emailAddr: string;
//   autopayFlag: boolean;
//   receiptFlag: boolean;
//   keyinFlag: boolean;
//   customParameter: string;
//   returnUrl: string;
//   callbackUrl: string;
//   cancelUrl: string;
//   inappFlag: string;
//   appReturnUrl: string;
//   appCancelUrl: string;
//   token: string;
//   onlineUrl: string;
//   mobileUrl: string;
//   billkey: string;
//   ipAddr: string;
//   tid: string;
//   cid: string;
//   payInfo: string;
//   domesticFlag: boolean;
//   transactionDate: string;
//   installMonth: number;
//   cardInfo: string;
//   payhash: string;
//   code: string;
//   message: string;
// }

export type VirtualAccount = {
  paymentId: string; // 결제내역 id
  accountNo: string; // 가상계좌 번호
  accountName: string; // 가상계좌 입금자명
  accountHolder: string; // 가상계좌 예금주명
  bankCode: string; // 가상계좌 은행 코드
  bankName: string; // 가상계좌 은행명
  issueTid: string; // 가상계좌 채번 승인번호
  expireDate: string; // 가상계좌 채번시 만료일 설정(YYYYMMDD)
  expireTime: string; // 가상계좌 채번시 만료시각 설정(HHMM)
};

export type CtPaymentCancel = {
  cancelId: number; // 취소내역 id
  tid: string; // 결제 고유번호
  cid: string; //승인번호
  cancelAmount: number; // 취소금액
  cancelDate: string; // 취소일자
};

export type CtPayment = {
  paymentId: number;
  billId: number;
  pgcode: string;
  orderNo: string;
  totalAmount: number;
  taxAmount: number;
  productName: string;
  tid: string;
  cid: string;
  payInfo: string;
  transactionDate: string;
  installMonth: number;
  cardInfo: string;
  virtualAccount?: VirtualAccount;
  paymentCancel: CtPaymentCancel;
  cancelList: CtPaymentCancel[];
  message: string;
};

export interface CtVirtualAcount {
  payId: number;
  accountNo: string;
  accountName: string;
  accountHolder: string;
  bankCode: string;
  bankName: string;
  issueTid: string;
  expireDate: string;
  expireTime: string;
}

export interface CtCashReceipt {
  payId: number;
  cashReceiptCid: string;
  cashReceiptDealNo: string;
  cashReceiptIssueType: boolean;
  cashReceiptPayerSid: string;
  cashReceiptType: string;
}

// interface CtPaymentCancel {
//   cancelId: number;
//   payId: number;
//   userId: string;
//   ipAddr: string;
//   tid: string;
//   cid: string;
//   cancelAmount: string;
//   partialAmount: string;
//   taxfreeAmount: string;
//   cancelDate: string;
//   code: string;
//   message: string;
// }

// export {
//   SpaceProductType,
//   ContractStep,
//   ApplicationName,
//   MediaServiceType,
//   MemberStatus,
//   VisitStatus,
//   PayStatus,
//   BillTimeType,
//   PayType,
//   PgCodeType,
//   searchStatusOption,
//   searchTypeOption,
//   searchDateTypeOption,
// };

export interface ContractManage {
  buildingId: string;
  buildingLocationCode: string;
  contractApplyNumber: string;
  contractManageId: string;
  contractId?: string;
  createdBy: string;
  createdDate: string;
  isDeleted: string;
  isMntProduct: string;
  mbOrganizationId: string;
  modifiedBy: string;
  modifiedDate: string;
  partnerId: string;
  providerId: string;
  spaceProductId: string;
  spaceProductName: string;
  spaceProductType: string;
  contractName?: string;
}

export interface GetContractManagementInformationParams {
  contractApplyNumber: string;
}

export interface GetContractManagementInformationResponse {
  contractManage: ContractManage;
  contractId: number;
}

export interface GetContractManageResponse {
  /**
   * 계약 이용신청 진행 단계
   * 하위호환 유지를 위해 항상 원계약(contractId 최소) 기준이다.
   * 재계약이 있는 계약관리에서는 이 값으로 계약 유효성을 판정하면 안 되고 contracts에서 대상 계약을 찾아야 한다.
   */
  contractStep: string;

  /** 계약 id. contractStep과 마찬가지로 항상 원계약을 가리킨다 */
  contractId: number;
  contractManage: ContractManage;
  // RCA18. 계약관리 하위 전체 계약 리스트 (재계약 1:N, 신청취소 포함 전체 상태)
  contracts?: Array<SiblingContract>;
}

export type ProductManageCalendarType = "NONE" | "GC" | "OC";

/** 계약-운영정보- productManage type*/
export interface ContractOperationProductManage {
  calendarType?: string;
  clientId?: string;
  clientSecretValue?: string;
  createdBy?: string;
  createdDate?: string;
  deskDailyTime?: number;
  deskTotalTime?: number;
  dummyUserEmail?: string;
  isDeleted?: boolean;
  isUseCalendar?: boolean;
  isUseDesk?: boolean;
  isUseMeetingRoom?: boolean;
  isUseOmega?: boolean;
  isUseRefreshRoom?: boolean;
  isUseVisitorInvite?: boolean;
  meetingRoomDailyTime?: number;
  meetingRoomTotalTime?: number;
  memberMaxNums?: number;
  memberNums?: number;
  modifiedBy?: string;
  modifiedDate?: string;
  refreshRoomDailyTime?: number;
  refreshRoomTotalTime?: number;
  tenantId?: string;
  isVisitorUnlimited?: boolean; // 방문자 수 제한 여부
  visitorNums?: number; // 방문자 수
  visitorMaxNums?: number; // 방문자 수 제한 값
  isUseVisitorSelfInvite?: boolean; // 방문자 셀프 등록 기능 사용 여부
  visitorApproverMemberType?: VisitorApproverMemberType; // 방문자 셀프 등록 승인 이용자 유형
  isUseVisitorTenantManagerApproval?: boolean; // 방문자 초대 승인 기능 사용 여부 (승인권자: 이용자 마스터 고정)
}

export interface ProductFacilityType {
  contractFacilityId: string;
  id: string;
  buildingId: string;
  buildingName: string;
  commonFacilityType: string;
  groupName: string;
  floorNum: number;
  isGround: boolean;
  facilityName: string;
  facilityMaxPeopleNums: number;
  description: string;
  eslAddress: string;
  resourceEmail: string;
  isDeleted: boolean;
}

export interface ContractProductManageModel {
  productFacility: Array<ProductFacilityType>;
}

/**
 * 2023-09-07 이후 변경된 API대응을 위한 type 정의
 * 상세 페이지 관련 타입 정의
 * ========================================
 */

export interface DetailTotalData {
  contract?: ContractDetail;
  contractManage?: ContractManagaDetail;
  // 같은 계약관리에 묶인 전체 계약 리스트 (재계약 1:N)
  contracts?: Array<SiblingContract>;
  scheduleList?: Array<BillingDetail>;
  billContactList?: Array<ContractorNoti>;
  contractOrganization?: MbOrgDetail;
  product?: any;
  provider?: ProviderDetailModel;
  room?: any;
  expenseProofData?: ExpenseProofRequest | null;
}

export interface SaveContractModel {
  contractManage: {
    partnerId: number;
    mbOrganizationId?: number;
    spaceProductId: number;
    spaceProductType: string;
    spaceProductName: string;
  };
  contract: {
    contractApplyType?: string;
    useStartTime: string;
    useEndTime: string;
    useTerm: number;
    applicantName?: string;
    applicantCorporation?: string;
    isAgreeTerms?: boolean;
  };
  contractMember: {
    memberNo: string;
    inviteMobileNumber: string;
  };
}
export interface ContractDetailWrap {
  contract?: ContractDetail;
}

// 견적서 타입
export interface QuotationModel {
  amount?: string; //총액
  quotationNo?: string; //CUID2 로 생성된 견적서의 Unique Key
  quotationItemList?: QuotationItem[]; //"견적 아이템 목록 연속된 시간끼리 하나의 item 으로 묶은 리스트를 전달"
  createdBy?: string; //[조회전용] 등록자 ID
  createdDate?: string; //[조회전용] 등록일시
  modifiedBy?: string; //[조회전용] 수정자 ID
  modifiedDate?: string; //[조회전용] 수정일시
  quotationId: string; // 견적서 id
}

export interface QuotationItem {
  id: string; // 견적서 item id
  quotationId: string; //견적서 id
  price: number; //아이템별 가격
  productId: string; //상품 id
  buildingCommonFacilityId: string; //공용공간 id
  startDate: string; //시작일시
  endDate: string; //종료일시
  quotationItemPrice: QuotationItemPrice[]; // [조회전용] 견적 아이템 가격 목록(로그정보)
}

export interface QuotationItemPrice {
  id: string; //견적서 아이템 요금 ID
  quotationItemId: string; //견적서 아이템 ID
  priceRuleId: string; //요금 룰 ID
  startDate: string; //시작일시
  endDate: string; //종료일시
  price: string; //판매가
  cost: string; //단가
}

export interface ContractDetail extends CommonDateNUser {
  contractId?: string | number;
  contractName?: string;
  /** 계약명(선택) */
  contractNickname?: string;
  contractManageId?: string | number;
  contractNumber?: string;
  contractStep?: string;
  contractApplyType?: string;
  useStartTime?: string;
  useEndTime?: string;
  useTerm?: number;
  applicantName?: string;
  applicantCorporation?: string;
  isAgreeTerms?: boolean;
  contractDate?: string;
  contractTerm?: number;
  contractStartTime?: string;
  contractEndTime?: string;
  depositAmount?: number;
  earnestAmount?: number;
  earnestPayStatus?: string;
  balanceAmount?: number;
  balancePayStatus?: string;
  contractBillTimeType?: string;
  pgcode?: string;
  payAmount?: number;
  taxAmount?: number;
  totalAmount?: number;
  isMntContain?: boolean;
  isDeleted?: boolean;
  eSignList?: [];
  billContactList?: Array<ContractorNoti>;
  mediaList?: Array<ContractMedia>;
  //==== harry가 추가 ======
  costType?: string; //
  colorName?: string; // 색상 명
  quotationList?: Array<QuotationModel>; // 견적서 목록
  approvalStatus?: ContractApprovalStatus; // 승인 상태
  approvalType?: ContractApprovalType; // 승인 유형
  contractorName?: string; // 계약자 이름
  pgcodeOption?: {
    items: Array<{
      pgcode: string;
      isEnabled: boolean;
      priority: number;
    }>;
  };
  isMemberCancelable?: boolean; // 이용자 취소 가능 여부
  memberCancelableMinutes?: number; // 이용자 취소 가능 시간
  // =====================
  // [key: string]: any;
}

export enum EsignType {
  Complete = "Complete",
  Canceled = "Canceled",
  Playing = "Playing",
  Truncate = "Truncate",
  Disposal = "Disposal",
}
export enum WorkflowType {
  WEBTYPE = "WEBTYPE",
  NORMAL = "NORMAL",
  FACEWEB = "FACEWEB",
  BULKTYPE = "BULKTYPE",
  GUIDE = "GUIDE",
}

export interface ESignListDetail extends CommonDateNUser {
  esignId?: number;
  contractId?: number;
  workflowName?: string;
  workflowId?: number;
  status?: EsignType;
  esignDetail?: ESignDetail;
}

export interface ESignDetail {
  workflowId?: number;
  workflowName?: string;
  starterName?: string;
  starterEmail?: string;
  workflowType?: WorkflowType;
  status?: EsignType;
  createdDate?: string;
  lastModifiedDate?: string;
  expiryDate?: string;
  businessId?: number;
  businessName?: string;
  order?: number;
  totalOrderCount?: number;
  certificateUrl?: string;
  previewUrl?: string;
  playingUrl?: string;
  downloadUrl?: string;
  history: Array<ESignHistory>;
  recipient: Array<ESignRecipient>;
  referer: Array<ESignReferer>;
  field: Array<ESignField>;
}
export interface ESignHistory {
  order?: number;
  name?: string;
  email?: string;
  comment?: string;
  createdDate?: string;
  status?: string;
}
export interface ESignRecipientAPIFormat {
  order: number;
  myTurn?: string;
  name: string;
  email: string;
  enableCertMobile?: string;
  mobile?: string;
  enableCertPassword?: string;
  password?: string;
  passwordHint?: string;
}
export interface ESignRecipient {
  order?: number;
  myTurn?: string;
  name?: string;
  email?: string;
  enableCertMobile?: string;
  mobile?: string;
  enableCertPassword?: string;
  password?: string;
  passwordHint?: string;
  [key: string]: any;
}
export interface ESignReferer {
  name?: string;
  email?: string;
  type?: string;
  [key: string]: any;
}
export interface ESignField {
  order?: number;
  name?: string;
  value?: string;
  email?: string;
  [key: string]: any;
}

export interface Template {
  templateId?: number;
  templateName?: string;
  templateType?: string;
  creatorEmail?: string;
  createdDate?: string;
  lastModifierEmail?: string;
  lastModifiedDate?: string;
  totalOrderCount?: number;
  templateWorkflowCount?: number;
  important?: boolean;
  folderId?: string;
  folderPath?: string;
  [key: string]: any;
}

export interface TemplateInfo {
  templateId?: number;
  templateName?: string;
  templateType?: string;
  creatorEmail?: string;
  createdDate?: string;
  lastModifierEmail?: string;
  lastModifiedDate?: string;
  totalOrderCount?: number;
  templateWorkflowCount?: number;
  important?: boolean;
  folderId?: string;
  folderPath?: string;
  previewUrl?: string;
  field: Array<TemplateField>;
  [key: string]: any;
}

export interface TemplateField {
  order?: number;
  fieldName?: string;
  fieldOwner?: string;
  [key: string]: any;
}
/**계약 알림 수신 정보*/
export interface ContractorNoti extends CommonDateNUser {
  billContactId?: string | number; //청구 연락처 ID
  receiveNotiType?: string; //수신알림 타입 (TALK_OFFICIALDOC : 알림톡/공문 수신, TAX_INVOICE : 세금계산서 수신)
  contact?: string; // 연락처
  email?: string; // 이메일
  description?: string; // 비고
  isDeleted?: boolean;
  [key: string]: any;
}

export interface ContractMedia extends CommonDateNUser {
  id?: string | number;
  serviceId?: string | number;
  serviceType?: string;
  serviceTag?: string;
  isPrimary?: boolean;
  orderNums?: number;
  contentType?: string;
  filename?: string;
  key?: string;
  fileSize?: string;
  fileStorageType?: string;
  isDeleted?: boolean;
  [key: string]: any;
}

export interface ContractManagaDetailWrap {
  contractManage?: ContractManagaDetail;
  // RCA25. 계약관리 하위 전체 계약 리스트 (재계약 1:N, 신청취소 포함 전체 상태)
  contracts?: Array<SiblingContract>;
}

/**
 * 같은 계약관리(contractManageId)에 묶인 형제 계약
 * 원계약과 재계약이 계약시작일 순으로 이어진다
 */
export type SiblingContract = ContractDetail;

export interface ContractManagaDetail extends CommonDateNUser {
  contractManageId?: string | number;
  partnerId?: string | number;
  providerId?: string | number;
  contractApplyNumber?: string;
  mbOrganizationId?: string | number;
  spaceProductId?: string | number;
  spaceProductType?: string;
  spaceProductName?: string;
  productCategory?: string;
  isMntProduct?: boolean;
  buildingLocationCode?: string;
  buildingId?: string | number;
  isDeleted?: boolean;
  contractorList?: Array<Contractor>;
  contractName?: string;

  [key: string]: any;
}

export interface Contractor extends CommonDateNUser {
  contractMemberId?: string | number;
  inviteMobileNumber?: string;
  memberNo?: string;
  isContractor?: boolean;
  isAdmin?: boolean;
  inviteDate?: string;
  memberStatus?: string;
  useTime?: number;
  memberPhoneNumber?: string;
  memberEmail?: string;
  isDeleted?: boolean;
  [key: string]: any;
}

export interface ContractBuildingRoom {
  buildingId?: string | number;
  buildingName?: string;
  createdBy?: string;
  createdDate?: string;
  floorId?: string | number;
  floorName?: string;
  floorNum?: number;
  isDeleted?: boolean;
  isGround?: boolean;
  leasableArea?: string;
  leasableAreaNet?: string;
  modifiedBy?: string;
  modifiedDate?: string;
  ownerId?: string | number;
  rent?: string;
  roomId?: string | number;
  roomName?: string;
  roomNum?: number;
}

export interface ContractBuildingRoomForTable extends CommonDateNUser {
  buildingId?: string | number;
  buildingName?: string;
  floorId?: string | number;
  floorName?: string;
  floorNum?: number;
  isDeleted?: boolean;
  isGround?: boolean;
  ownerId?: string | number;
  rent?: string;
  rooms?: string;
}

export const monthDays = [
  { label: "1일", value: 1 },
  { label: "2일", value: 2 },
  { label: "3일", value: 3 },
  { label: "4일", value: 4 },
  { label: "5일", value: 5 },
  { label: "6일", value: 6 },
  { label: "7일", value: 7 },
  { label: "8일", value: 8 },
  { label: "9일", value: 9 },
  { label: "10일", value: 10 },
  { label: "11일", value: 11 },
  { label: "12일", value: 12 },
  { label: "13일", value: 13 },
  { label: "14일", value: 14 },
  { label: "15일", value: 15 },
  { label: "16일", value: 16 },
  { label: "17일", value: 17 },
  { label: "18일", value: 18 },
  { label: "19일", value: 19 },
  { label: "20일", value: 20 },
  { label: "21일", value: 21 },
  { label: "22일", value: 22 },
  { label: "23일", value: 23 },
  { label: "24일", value: 24 },
  { label: "25일", value: 25 },
  { label: "26일", value: 26 },
  { label: "27일", value: 27 },
  { label: "28일", value: 28 },
];

export interface ModalDataWrap {
  commonModals: ModalDatas;
}
export interface ModalDatas {
  popupState: boolean;
  typeString?: string;
  title?: string;
  confirm?: any;
  cancel?: any;
  message?: string;
  subTitle?: string;
}
export const disabledApply: Array<String> = [ContractStep.APPLY_RECEIVED, ContractStep.APPLY_CANCEL, ContractStep.APPLY_CONFIRM];

export const diabledOverdueFee: Array<String> = [
  ContractStep.APPLY_CANCEL, // 신청취소
  // ContractStep.CONTRACT_PLAN, // 계약예정
  // ContractStep.APPLY_RECEIVED, // 신청접수
  // ContractStep.APPLY_CONFIRM, // 신청확인
];
export const disabledIsAutoBilling: Array<String> = [
  ContractStep.APPLY_CANCEL,
  ContractStep.TERMINATE_COMPLETE,
  ContractStep.APPLY_CONFIRM,
  ContractStep.USE_COMPLETE,
];
export const disabledPayRegularDay: Array<string> = [
  ContractStep.APPLY_CANCEL,
  ContractStep.TERMINATE_COMPLETE,
  ContractStep.APPLY_CONFIRM,
  ContractStep.USE_COMPLETE,
];
export const disabledBillingStartEnd: Array<string> = [
  ContractStep.APPLY_CANCEL,
  ContractStep.CONTRACT_ACCEPT,
  ContractStep.USE_APPROVAL,
  ContractStep.USE_PROGRESS,
  ContractStep.TERMINATE_RECEIVED,
  ContractStep.TERMINATE_COMPLETE,
  ContractStep.USE_COMPLETE,
];

export const disabledEsignEdit: Array<string> = [
  ContractStep.APPLY_CANCEL,
  ContractStep.APPLY_RECEIVED,
  ContractStep.APPLY_CONFIRM,
  ContractStep.TERMINATE_COMPLETE,
  ContractStep.USE_COMPLETE,
];

export const disabledBeforeContractPlan: Array<string> = [
  ContractStep.APPLY_RECEIVED,
  ContractStep.APPLY_CONFIRM,
  ContractStep.CONTRACT_PLAN,
  // ContractStep.CONTRACT_ACCEPT,
];
export const disabledBeforeContractAccept: Array<string> = [
  ContractStep.APPLY_RECEIVED,
  ContractStep.APPLY_CONFIRM,
  ContractStep.CONTRACT_PLAN,
  ContractStep.CONTRACT_ACCEPT,
];
export const priceChangeStatus: Array<string> = [
  ContractStep.APPLY_RECEIVED,
  ContractStep.APPLY_CONFIRM,
  ContractStep.CONTRACT_PLAN,
  ContractStep.CONTRACT_ACCEPT,
  ContractStep.USE_APPROVAL,
  ContractStep.USE_PROGRESS,
];
export const priceChangeStatus2: Array<string> = [ContractStep.CONTRACT_ACCEPT, ContractStep.USE_APPROVAL, ContractStep.USE_PROGRESS];

export const disabledScheduleListEdit: Array<string> = [
  ContractStep.APPLY_CANCEL,
  ContractStep.APPLY_RECEIVED,
  ContractStep.APPLY_CONFIRM,
  ContractStep.USE_APPROVAL,
  ContractStep.USE_PROGRESS,
  ContractStep.TERMINATE_RECEIVED,
  ContractStep.TERMINATE_COMPLETE,
  ContractStep.USE_COMPLETE,
];

// 공간임대 상품 빌링스케줄 수정 버튼 비노출
export const disabledEdit: Array<string> = [
  ContractStep.APPLY_CANCEL, // 신청취소
  ContractStep.APPLY_RECEIVED, // 신청접수
  ContractStep.APPLY_CONFIRM, // 신청확인
  ContractStep.CONTRACT_PLAN, // 계약예정

  // v.1.33.2 에 수정 > 공간임대 상품 이용완료 / 해지완료에서도 수정 버튼 노출위함
  // ContractStep.USE_COMPLETE, // 이용완료
  // ContractStep.TERMINATE_COMPLETE, // 해지완료
];

export const disabledScheduleBillEdit: Array<string> = [
  ContractStep.APPLY_CANCEL, // 신청취소
  ContractStep.APPLY_RECEIVED, // 신청접수
  ContractStep.USE_COMPLETE, // 이용완료
  ContractStep.TERMINATE_COMPLETE, // 해지완료

  // 활성화로 변경 > 주석처리
  // ContractStep.APPLY_CONFIRM, // 신청확인
  // ContractStep.CONTRACT_PLAN, // 계약예정
  // ContractStep.USE_PROGRESS, // 이용중
  // ContractStep.TERMINATE_RECEIVED, // 해지접수
];

// 공간예약 상품 빌링스케줄 수정 버튼 비노출
export const s2DisabledEdit: Array<string> = [
  ContractStep.APPLY_CANCEL, // 신청취소
  ContractStep.CONTRACT_ACCEPT, // 계약체결
  ContractStep.USE_APPROVAL, // 이용승인
  ContractStep.USE_PROGRESS, // 이용중
  ContractStep.USE_COMPLETE, // 이용완료
];
export interface SaveEsignDatas {
  workflowName?: string;
  templateId?: number;
  comment?: string;
  expiryDate?: string;
  recipientList?: Array<ESignRecipient> | Array<ESignRecipientAPIFormat>;
  [key: string]: any;
}
/**
 * 2023-09-07 이후 변경된 API대응을 위한 type 정의
 * 수정 페이지 관련 타입 정의
 * ========================================
 */

/**
 * 2023-10-18 작업
 * RCA02. 계약 신청 (v1.8 이후)
 * POST /api/ctrl/partners/{partnerId}/ct/contract/apply
 */
export interface NewContractSaveModel {
  productId: number;
  isAgreeTerms: boolean;
  useStartTime: string;
  useEndTime: string;
  useTerm?: number;
  contractApplyType: string;
  applicantMemberNo: string;
  applicantMobile: string; //M.164
  applicantName?: string;
  applicantCorporation?: string;
  mbOrganizationId?: number;
  pgcode?: string;
  // harry 가 존에 만들어진 신청계약에 맞게 그냥 추가함
  selectedFacility?: any;
  email?: string;
  // ================================
}

// 계약 > 이용신청서 저장 타입
export interface ContractApplicationWrap {
  applicationId?: number; // [조회전용] 이용신청 id
  useStartTime?: string; //이용 시작 일시
  useEndTime?: string; //이용 종료 일시
  applicantName?: string; //신청자명
  applicantCorporation?: string; //신청자 법인명/상호
  applicantPhoneNumber?: string; //신청자 전화번호
  applicantEmail?: string; //신청자 이메일
  applicantMemberNo?: string; //신청자 회원번호
  isAgreeTerms: boolean; // 약관동의 여부
  attachments?: SaveMediaDto[];
  formData?: ApplicationFormModel;
}

// new 계약생성 타입 (이용 신청서 포함)
export interface ContractRequest {
  productId: number;

  applicationHeader: {
    mbOrganizationId?: number;
    memberNo: string;
    pgcode?: string;
    quotationId?: number;
    zoneId?: string;
  };
  applicationBody: ContractApplicationWrap;
}

/**
 * RCA01. 재계약 신청 타입
 * 원계약(originContractId)을 복사해 같은 계약관리 하위에 새 계약을 생성한다.
 * 상품/계약조건은 Core에서 원계약을 승계하므로 상품 id를 전달하지 않는다.
 */
export interface RenewContractRequest {
  originContractId: number;
  applicationHeader?: {
    mbOrganizationId?: number;
    // 미전달 시 원계약 계약관리자(계약자)의 회원번호로 자동 설정
    memberNo?: string;
    zoneId?: string;
  };
  applicationBody: ContractApplicationWrap;
}

export interface RenewContractResponse {
  contractManageId: number; // 원계약과 공유
  contractId: number; // 재계약으로 생성된 계약
}

// Application 신청정보 상세조회 type
export type ContractApplicationModel = {
  spaceProductId: number; // 공간상품 ID
  spaceProductName: string; // 공간상품 명
  spaceProductType: ProductTypeT; // 공간상품 타입
  providerId: number; // 프로바이더 ID
  providerName: string; // 프로바이더 명
  partnerId: number; // 파트너 ID
  applicationBody: ContractApplicationWrap; //이용신청서
  memberNo: string; //계약자 회원번호
  contractorPhoneNumber: string; //계약자 전화번호
  contractorEmail: string; //계약자 이메일
  contractorName: string; //계약자 이름
};

//신청계약 공용공간 탭

export interface ProductManage {
  memberNums?: number; // 공간상품 현 이용자수
  memberMaxNums?: number; // 공간상품 최대 이용자수
  isUnlimitedMeetingRoom?: boolean; // 회의실 예약무제한 여부
  isAllowedMeetingRoomOverReservation?: boolean; // 회의실 초과예약 허용 여부
  isLimitedMeetingRoomMonthlyReservation?: boolean; // 회의실 월별 예약제한 사용 여부
  isLimitedMeetingRoomDailyReservation?: boolean; // 회의실 일별 예약제한 사용 여부
  meetingRoomTotalTime?: number; // (공용시설) 회의실 월별 총 예약가능 시간(분 단위)
  meetingRoomDailyTime?: number; // (공용시설) 회의실 일별 총 예약가능 시간(분 단위)
  isUnlimitedRefreshRoom?: boolean; // 리프레쉬룸 예약무제한 여부
  isAllowedRefreshRoomOverReservation?: boolean; // 리프레쉬룸 초과예약 허용 여부
  isLimitedRefreshRoomMonthlyReservation?: boolean; // 리프레쉬룸 월별 예약제한 사용 여부
  isLimitedRefreshRoomDailyReservation?: boolean; // 리프레쉬룸 일별 예약제한 사용 여부
  refreshRoomTotalTime?: number; // (공용시설) 리프레쉬룸 월별 총 예약가능 시간(분 단위)
  refreshRoomDailyTime?: number; // (공용시설) 리프레쉬룸 일별 총 예약가능 시간(분 단위)
  isUnlimitedDesk?: boolean; // 1인 데스크 예약무제한 여부
  isAllowedDeskOverReservation?: boolean; // 1인 데스크 초과예약 허용 여부
  isLimitedDeskMonthlyReservation?: boolean; // 1인 데스크 월별 예약제한 사용 여부
  isLimitedDeskDailyReservation?: boolean; // 1인 데스크 일별 예약제한 사용 여부
  deskTotalTime?: number; // (공용시설) 1인 데스크 월별 총 예약가능 시간(분 단위)
  deskDailyTime?: number; // (공용시설) 1인 데스크 일별 총 예약가능 시간(분 단위)
  isUseMeetingRoom?: boolean; // (공용시설) 회의실 사용여부
  isUseRefreshRoom?: boolean; // (공용시설) 리프레쉬룸 사용여부
  isUseDesk?: boolean; // (공용시설) 데스크 사용여부
  isUseVisitorInvite?: boolean; // 방문자 초대 사용여부
  isUseVisitorTenantManagerApproval?: boolean; // 방문자 초대 승인 기능 사용 여부 (승인권자: 이용자 마스터 고정)
  isUseCalendar?: boolean; // 캘린더연동 사용여부
  dummyUserEmail?: string; // 더미 유저 이메일
  calendarType?: string; // 캘린더 종류 (NONE : 미사용, GC : Google Calendar, OC : Outlook Calendar)
  tenantId?: string; // [캘린더 종류: OC] 테넌트 ID
  clientId?: string; // [캘린더 종류: OC] 클라이언트 ID
  clientSecretValue?: string; // [캘린더 종류: OC] 클라이언트 암호값
  isDeleted?: boolean; // 삭제여부
  createdDate?: string; // 등록일자
  createdBy?: string; // 등록자ID
  modifiedDate?: string; // 수정일자
  modifiedBy?: string; // 수정자ID
  vocUrl?: string; //문의채널
}

export interface ProductFacilityUsedTime {
  meetingRoomMonthlyUsedTime?: number; // (공용시설) 회의실 월 누적 사용시간(분 단위)
  meetingRoomDailyUsedTime?: number; // (공용시설) 회의실 일 누적 사용시간(분 단위)
  refreshRoomMonthlyUsedTime?: number; // (공용시설) 리프레쉬룸 월 누적 사용시간(분 단위)
  refreshRoomDailyUsedTime?: number; // (공용시설) 리프레쉬룸 일 누적 사용시간(분 단위)
  deskMonthlyUsedTime?: number; // (공용시설) 1인 데스크 월 누적 사용시간(분 단위)
  deskDailyUsedTime?: number; // (공용시설) 1인 데스크 일 누적 사용시간(분 단위)
}

export interface ContractFacility {
  contractFacilityId?: string; // 계약 공용시설 ID
  id?: string; // 건물 공용시설 ID (공간상품 관리)
  resourceEmail?: string; // 리소스 캘린더 ID
  isUnlimitedReservation?: boolean; // 예약 무제한 여부
  isAllowedOverReservation?: boolean; // 초과예약 허용 여부
  isLimitedMonthlyReservation?: boolean; // 월별 예약제한 사용 여부
  monthlyServiceMinutes?: number; // 월별 제공시간(분)
  isLimitedDailyReservation?: boolean; // 일별 예약제한 사용 여부
  dailyServiceMinutes?: number; // 일별 예약제한 시간(분)
  isDeleted?: boolean; // 삭제여부
  createdDate?: string; // 등록일자
  createdBy?: string; // 등록자ID
  modifiedDate?: string; // 수정일자
  modifiedBy?: string; // 수정자ID
}

export interface ContractOperationDetail {
  spaceProductId?: string; // 공간상품 ID
  productManage?: ProductManage; // 공간상품 관리 정보
  productFacilityUsedTime?: ProductFacilityUsedTime; // 공용시설 사용 시간 정보
  productFacility?: ContractFacility[]; // 계약 공용시설 배열
}

export interface CtProductFacilityType {
  contractFacilityId: string; // 계약 공용시설 ID
  id: string; // 건물 공용시설 ID (공간상품 관리)
  resourceEmail: string; // 리소스 캘린더 ID
  isUnlimitedReservation: boolean; // 예약 무제한 여부
  isAllowedOverReservation: boolean; // 초과예약 허용 여부
  isLimitedMonthlyReservation: boolean; // 월별 예약제한 사용 여부
  monthlyServiceMinutes: number; // 월별 제공시간(분)
  isLimitedDailyReservation: boolean; // 일별 예약제한 사용 여부
  dailyServiceMinutes: number; // 일별 예약제한 시간(분)
  isDeleted: boolean; // 삭제여부
  createdDate: string; // 등록일자
  createdBy: string; // 등록자 ID
  modifiedDate: string; // 수정일자
  modifiedBy: string; // 수정자 ID
}

export interface ExpenseProofRequest {
  contractId: number;
  expenseProofType: string;
  identityType: string;
  identityNum: string;
  tradeUsage: string | null;
  taxInvoiceEmail: string | null;
  taxInvoiceManager: string | null;
  taxInvoicePhone: string | null;
  description: string | null;
  isDeleted: boolean;
  createdDate: string;
  createdBy: string;
  modifiedDate: string;
  modifiedBy: string;
}

export interface CtBuildingManage {
  buildingManageId: number;
  contractManageId: number;
  buildingId: number;
  isPrimary: boolean;
  isDeleted: boolean;
  createdDate: string;
  createdBy: string;
  modifiedDate: string;
  modifiedBy: string;
}

export interface ProductCheck {
  productInfo: {
    productId: number;
    isValidated: boolean;
  };
}
export interface ChangeProductAvailable {
  product: {
    id: number;
    isContractAvail: boolean;
  };
}

// 계약 상품 스냅샷 타입
/**
 * 계약 상품 속성 스냅샷 모델
 * 계약 시점의 상품 속성 정보를 저장하는 타입
 */
export type ContractProductSnapshotModel = {
  attrId: string; // 속성 ID
  contractManageId: number; // 계약관리 ID
  domain: string; // 도메인
  domainId: number; // 도메인 ID
  attrName: string; // 속성명
  initValue: string; // 속성초기값
  attrValue: string; // 속성값
  nestedId: string; // 중첩 ID
  orderNums: string; // 순번 (도메인 내 순서)
  isDeleted: boolean; // 삭제여부
  createdDate: string; // 생성일
  createdBy: string; // 생성자
  modifiedDate: string; // 수정일
  modifiedBy: string; // 수정자
};

export interface CtApplicationFile {
  id: number;
  serviceType?: string;
  isPrimary?: boolean;
  orderNums?: number;
  contentType?: string;
  filename?: string;
  key?: string;
  fileSize?: number;
  fileStorageType?: string;
}

export interface QuotationItemListModel {
  productId?: string;
  buildingCommonFacilityId: string;
  startDate: string;
  endDate: string;
}
